import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  
 body, html {
     height: auto;
     font-family: 'Prompt', sans-serif !important;
     margin: 0px;
     padding: 0px;
     letter-spacing: .2px;
     overflow-x: hidden !important;
  }
  
  p, h2, ul {
     margin-bottom: 0;
  }

  a {
    cursor: pointer;
    text-decoration: none;
    outline: none !important;
  }

  .ant-select-item-option-content {
    font-size: 16px;
  }
  .overflow-hidden-body {
    overflow: hidden;
  }
  .ant-empty-normal{
    margin: 10px 0px !important;
  }
  .ant-select-item-option-active:not(.ant-select-item-option-disabled) {
    background-color: rgb(193 30 198 / 40%);
  }

  .ant-card-cover img {
    border-radius: 5px 0px 0px 5px;
  }
  .ant-modal-content {
    margin: 10px;
  }
  .ant-tabs-top>.ant-tabs-nav .ant-tabs-ink-bar, .ant-tabs-top>.ant-tabs-nav:before, .ant-tabs-top>div>.ant-tabs-nav .ant-tabs-ink-bar, .ant-tabs-top>div>.ant-tabs-nav:before {
    bottom: -5px;
  }
  .ads-block {
    max-width: 300px;
    display: block;
    max-height: 250px;
    overflow: hidden;
    margin: auto;
  }
`;
